<template>
<div>
  <Breadcrumb :title="'Partner Capital Activity Report'"></Breadcrumb>
  <div class="input-group">
        <div class="form-group col-md-12">
            <label class="section-title">Select Report Criteria</label>
        </div>
        <br>
        <div class="input-group">
            <div class="form-group col-md-12">
                <div class="multi-field multi-field-left col-md-4">
                    <label style="display:block">Program</label>
                     <div id="kendo-select">
                      <kendo-dropdownlist v-model="criteriaData.Program"
                                :data-source="dropdowns.Program"
                                :data-text-field="'Option'"
                                :option-label="'Select Program'"
                                :data-value-field="'Id'">
                      </kendo-dropdownlist>
                    </div>
                </div>
                <div class="multi-field col-md-8">
                  <kendo-daterangepicker id="rangePicker"
                           :range="currentRange"
                           :format="'MM/dd/yyyy'"
                           v-on:change="onChange">
                  </kendo-daterangepicker>
                </div>
            </div>
        </div>
        <br>
        <div class="row" style="width: 100%">
            <div class="col text-center">
                <button class="btn btn-primary" 
                :disabled="criteriaData.Program == '' || criteriaData.StartDate == '' || criteriaData.EndDate == ''"
                style="margin:auto" @click="getReportData"><span class="fa fa-list"></span> &nbsp;Run Report</button>
            </div>
        </div>
    </div>
    <br>
        
  <div class='btnDiv'>
    <BaseToolBar v-if="displayGrid"  @buttonClicked="toolbarOnClick"></BaseToolBar>
  </div>
  <div>
    <BaseGrid v-show="displayGrid" :config="GridConfig" :excelExport="excelExport" :mode="'editform'" :data="PartnerCapitalReportData"  ></BaseGrid>
  </div>
</div>
</template>

<script>
import $ from 'jquery';
import { GridConfig}  from "./PartnerCapitalReportConfig.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";

import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import BaseModelDistribution from "@/models/BaseModelDistribution.js";
import BaseModelBuyout from "@/models/BaseModelBuyout.js";

import {mapGetters, mapActions, mapState } from 'vuex';
import moment from "moment";
// import deepGroupBy from "@/services/groupByUtil.js";

export default {
  name: "PartnerCapitalReport",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  components: {
    Breadcrumb,
    BaseGrid,
    BaseToolBar,
  },
   computed: {
    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),
     
  },
  data: function () {
    return {
      currentRange: {start: null, end: null},
      GridConfig: GridConfig,
      currentGridConfig:{},
      grid: $("#" + GridConfig.grid.gridId).data("kendoGrid"),
      search: {
        SearchData: "",
      },
      PartnerCapitalReportGridId: GridConfig.grid.gridId,
    //   ToolbarConfig: ToolbarConfig,      
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelProgram: BaseModelProgram,   
      dropdowns: {
        Program: { model: "", dataSource: [] },        
      },
      displayGrid:false,
      criteriaData: {
            Program: "", 
            StartDate: "", 
            EndDate: "" 
      },
      PartnerCapitalReportData:[],
    }
  },
  mounted() {
    const self = this;
    console.log(self.grid)
    self.currentGridConfig = JSON.parse(JSON.stringify(self.GridConfig));
    self.getInputControls(); 
  },
  methods: {
    ...mapActions("postModule",['DeleteItem']),
    onChange: function (e) {
        this.criteriaData.StartDate =  e.sender._range.start?e.sender._range.start:'';
        this.criteriaData.EndDate = e.sender._range.end?e.sender._range.end:'';
    },
    getInputControls: function () {
        const self = this;

        let resProgram = self.withFilter(self.BaseModelProgram.list,"");

        let programData = [];
        if (resProgram.length) {
            resProgram.forEach(item => {
                let obj = {};
                obj.Id = item.Id;
                obj.Option = item.Title;
                programData.push(obj);
            });
        }
        self.dropdowns["Program"] =  programData.sort((a,b) => {
          return a.Option.localeCompare(b.Option)
        });
    },

    getReportData: function (e) {
            e.preventDefault();
            let loader = this.$loading.show();
            let self = this; 
            self.displayGrid = false;
            self.PartnerCapitalReportData = [];
            self.currentGridConfig = JSON.parse(JSON.stringify(self.GridConfig));
            self.$nextTick(function () {
              // let multiSelect = $("#PartnerMultiSelect").data("kendoMultiSelect");
              let SelectedPartnerCount = self.criteriaData.Program.length;
              // alert(SelectedPartnerCount);

              if (self.criteriaData.Program !="" && self.criteriaData.StartDate !="" && self.criteriaData.StartDate !=null  && self.criteriaData.EndDate !="" && self.criteriaData.EndDate !=null) {
                  self.getPartnerCapitalReportData();

              } else {
                  self._AlertPopup("Please select Program, Start Date and End Date to proceed!", "warning");
              }
              loader.hide();
            });

    },

    getPartnerCapitalReportData: function(){  
        let self = this; 
        self.PartnerCapitalReportData = [];
        //TODO
        //Get Records from TransactionLog Table
        // Filter TransactionDate Between Start and End Date and Business Event ="Issuance"
        let tranLogFilterQuery ={
          batchQuery:true,
              filter : function(o){
                  return o.ProgramId == self.criteriaData.Program && o.BusinessEvent =='Issuance' && (new Date(o.TransactionDate)>=new Date(self.criteriaData.StartDate ) && new Date(o.TransactionDate) <= new Date(self.criteriaData.EndDate))
              }
        }
    
        let TransactionLogData = this.withFilter(BaseModelTransactionLog.list,tranLogFilterQuery);

        if (TransactionLogData && TransactionLogData.length>0) {
          TransactionLogData.forEach(ele => {
            let tranLogRow={};
            let UnitPrice=0;
            tranLogRow.CapitalType="Tax"
            tranLogRow.Level="Partner"
            tranLogRow.PartnerId=ele.PartnerId
            tranLogRow.PartnerID=ele.PartnerID
            tranLogRow.PartnerName=ele.PartnerFullName
            tranLogRow.ReportDate=ele.TransactionDate
            tranLogRow.Currency="USD"

            //Get UnitPrice from UnitClass using Program and UnitClass
            let UnitClassResponse= self.withFilter(BaseModelUnitClass.list,{filter:"ProgramId eq "+ ele.ProgramId +" and UnitClass eq "+"'"+ele.UnitClass+"'"})
            if (UnitClassResponse && UnitClassResponse[0]) {
              UnitPrice=UnitClassResponse[0].UnitPrice
            }
            tranLogRow.CashContribution=(ele.Unit * UnitPrice)
            tranLogRow.CashDistribution=""
            tranLogRow.PropertyDistribution=""
            
            self.PartnerCapitalReportData.push(tranLogRow)
           
          });
        }
        //TODO
        //Distribution Part
        let distFilterQuery ={
          batchQuery:true,
              filter : function(o){
                  return o.ProgramId == self.criteriaData.Program && o.DistributionPartnerType =='Partner' && (new Date(o.DistributionDate)>=new Date(self.criteriaData.StartDate ) && new Date(o.DistributionDate) <= new Date(self.criteriaData.EndDate))
              }
        }
    
        let DistributionData = this.withFilter(BaseModelDistribution.list,distFilterQuery);
        if (DistributionData && DistributionData.length>0) {
          DistributionData.forEach(ele => {
            let distRow={};
            distRow.CapitalType="Tax"
            distRow.Level="Partner"
            distRow.PartnerId=ele.PartnerId
            distRow.PartnerID=ele.PartnerPartnerID
            distRow.PartnerName=ele.PartnerFullName
            distRow.ReportDate=ele.DistributionDate
            distRow.Currency="USD"
            distRow.CashContribution=""
            distRow.CashDistribution=ele.DistributionAmount
            
            distRow.PropertyDistribution=""
            
            self.PartnerCapitalReportData.push(distRow)
           
          });
        }
        //Property Distribution Records
        self.getPropertyDistribution()

        //self._AlertPopup("Report Generation In Progress","info")
        self.displayGrid = true;
        self.$nextTick(function () {
        self._loadGridSettings("PartnerCapitalReportGrid");
        });

    },
    getPropertyDistribution(){
      //Get Buyout Details
      let self=this;
            let buyoutQuery ={
              batchQuery:true,
                  filter : function(o){
                      return o.WorkflowStatus =="Approved" && o.ProgramId == self.criteriaData.Program && (new Date(o.PartnerLeaveDate)>=new Date(self.criteriaData.StartDate) && new Date(o.PartnerLeaveDate) <= new Date(self.criteriaData.EndDate))
                  }
            } 
            let BuyoutData= self.withFilter(BaseModelBuyout.list,buyoutQuery)
            if (BuyoutData && BuyoutData.length>0) {
                BuyoutData.forEach(ele => {
                  if (ele.ContributionRelief>0) {
                    let buyOutRow={};
                    buyOutRow.CapitalType="Tax"
                    buyOutRow.Level="Partner"
                    buyOutRow.PartnerId=ele.PartnerId
                    buyOutRow.PartnerID=ele.PartnerID
                    buyOutRow.PartnerName=ele.PartnerFullName
                    buyOutRow.ReportDate=ele.PartnerLeaveDate
                    buyOutRow.Currency="USD"
                    buyOutRow.CashContribution=""
                    buyOutRow.CashDistribution=""
                    
                    buyOutRow.PropertyDistribution=ele.ContributionRelief
                    
                    self.PartnerCapitalReportData.push(buyOutRow)
                  }
                
            });
          }
    },

    
    toolbarOnClick: function (e) {
      let self=this;
      e.preventDefault();
      switch (e.id) {   
        case "btnRefresh":
          this.refreshGrid();
          break;
      }

      let resProgram = self.withFilter(self.BaseModelProgram.list,{filter : "Id eq " + self.criteriaData.Program})[0];
       var headerList=[
        {id:"Program Name", value:resProgram.InvestmentTitle},
        {id:"Report Start Date", value:kendo.toString(this.criteriaData.StartDate, "MM/dd/yyyy")},
        {id:"Report End Date", value:kendo.toString(this.criteriaData.EndDate, "MM/dd/yyyy")},
        {id:"Report Generated On", value:kendo.toString(new Date, "MM/dd/yyyy")}]
      //var fileName = ssn+"_"+PartnerName+"_"+asOfDate+"_Investor Report.xlsx";
      var arguementList={
        ...arguments,
        fileName:resProgram.InvestmentTitle+"_Partner Capital Activity Report"+".xlsx",
        //Investor Report_"+kendo.toString(new Date, "MM-dd-yyyy")+".xlsx",
        headers:headerList
      }

      this._baseToolBarEvents("PartnerCapitalReportGrid", arguementList);
    },
    refreshGrid: function(){  

    },
   
  },
}
</script>
<style>
  #rangePicker{
    border: 0 !important;
  }
  #rangePicker .k-textbox{
    height: 40px;
    margin-top: 10px;
    background:#F0F0F0!important;
	  top: 2.5px!important;
  }
  #rangePicker .k-textbox-container{
    width: 49% !important;
  }
</style>
<style scoped>
.k-widget{
	font-size:1.12rem!important;
}
</style>
